import { render } from "./Change Password.vue?vue&type=template&id=3009f9f6"
import script from "./Change Password.vue?vue&type=script&lang=js"
export * from "./Change Password.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__